export default __webpack_public_path__ + "static/media/04.53dfe20c.jpg";